import { DashboardResponse, ContractSummaryResponse } from "src/app/pages/dashboard-page/services/dashboard.service";
import { getContractFixtures } from "src/app/v2/mocks/contracts/contract-fixtures";
import { EpkFamilyPerformanceResponse } from "src/app/pages/dashboard-page/models/epk-family-performance.models";
import {
  deriveContractSummary,
  deriveContractSummaryFacts,
  deriveEpkFamilyPerformance,
  deriveUserSummary,
} from "src/app/v2/mocks/derive-summaries";
import { MockScenario } from "src/app/v2/mocks/mock-scenario";

/**
 * Derives the /user/summary payload. The withdrawal age is unknown (null), so the withdrawal card stays hidden
 * offline, as before. Offline mode has no Customer Master mock, so the old date-of-birth check never showed it either.
 */
export const generateUserSummary = (scenario: MockScenario): DashboardResponse => ({
  payload: { ...deriveUserSummary(getContractFixtures(scenario.contracts)), hasReachedWithdrawalAge: null },
});

/** Derives the /contracts/summary payload, with the dashboard facts. See derive-summaries.ts for the derivation logic. */
export const generateContractSummary = (scenario: MockScenario): ContractSummaryResponse => {
  const fixtures = getContractFixtures(scenario.contracts);

  return {
    payload: { ...deriveContractSummary(fixtures), ...deriveContractSummaryFacts(fixtures) },
  };
};

/** Derives the /contracts/epk-family/performance payload for the revenue modal. See derive-summaries.ts. */
export const generateEpkFamilyPerformance = (scenario: MockScenario): EpkFamilyPerformanceResponse => ({
  payload: deriveEpkFamilyPerformance(getContractFixtures(scenario.contracts)),
});

/**
 * Mock data for dashboard user articles
 * Note: This is wrapped in the API response structure (body.payload)
 * to match what getUserArticles returns
 */
export const userArticlesMock = {
  payload: [
    {
      trackId: "link-article_card_pension",
      title: {
        no: "Syns du pensjon er komplisert?",
        en: "Do you find pension complicated?",
      },
      content: {
        no: "Her får du pensjon kort forklart!",
        en: "Pension made simple!",
      },
      imageUrl: "",
      buttonText: {
        no: "",
        en: "",
      },
      buttonVariant: "primary",
      href: "",
      target: "_blank",
      routerLink: "",
      queryParams: {},
      videoPosterUrl:
        "https://storebrand.brandmaster.com/fr/gallery/12656/images/lowres/838cb7a8-04f8-4deb-92c3-9459712e87c1.png?cacheVersion=1764677235",
      videoUrl: "https://api.screen9.com/embed/-FLMTE-zRvv7tt592RNaYA?controls=true",
      videoText: "0:54 min",
      expirationDate: "2030-12-30",
    },
    {
      trackId: "link-article_3",
      title: {
        no: "Fire nyttårsgrep som gir deg bedre pensjon",
        en: "Four New Year's steps to boost your pension",
      },
      content: {
        no: "Mange vet ikke hva de kommer til å få i pensjon. Det kan bli dyrt!",
        en: "Many people do not know what they will receive in pension. It could become expensive!",
      },
      imageUrl:
        "https://storebrand.brandmaster.com/fr/gallery/12656/images/lowres/2071e35035b343df9fcdd116dde944c4.png?cacheVersion=1647962062",
      buttonText: {
        no: "Les mer",
        en: "Read more",
      },
      buttonVariant: "primary",
      href: "https://www.storebrand.no/privat/pensjon/slik-far-du-bedre-pensjon",
      target: "_blank",
      routerLink: "",
      queryParams: {
        referrer: "min-pensjon",
      },
      expirationDate: "2030-12-30",
      startDate: "2025-12-23",
    },
    {
      trackId: "link-article_card_overview",
      title: {
        no: "Rask oversikt - rett i lomma!",
        en: "Quick overview - in your pocket!",
      },
      content: {
        no: "Prøv Storebrands app Kron!",
        en: "Try Storebrand's app Kron!",
      },
      imageUrl:
        "https://storebrand.brandmaster.com/fr/gallery/12656/images/lowres/18afcb9d-8186-457d-90e0-0fe09e389dfa.png?cacheVersion=1759906062",
      buttonText: {
        no: "Les mer",
        en: "Read more",
      },
      buttonVariant: "primary",
      href: "https://www.storebrand.no/privat/pensjon/krontroll",
      target: "_blank",
      routerLink: "",
      queryParams: {
        referrer: "min-pensjon",
      },
      expirationDate: "2030-12-30",
    },
  ],
};
